//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { dateFormat, datetimeFormat } from '@/plugin/format.js'
import FileSaver from 'file-saver'
import XLSX from 'xlsx'
import moment from 'moment'
export default {
  data() {
    return {
      datas: [],
      filters: {
        keyword: '',
        fromTime: null,
        toTime: null,
        status: '',
        repairshop: ''
      },
      pickerOptionsS: {
        disabledDate: time => {
          if (this.filters.toTime !== null) {
            return (
              time.getTime() > Date.now() ||
              time.getTime() > this.filters.toTime
            )
          } else {
            return time.getTime() > Date.now()
          }
        }
      },
      pickerOptionsE: {
        disabledDate: time => {
          return (
            time.getTime() < this.filters.fromTime ||
            time.getTime() > Date.now()
          )
        }
      }
    }
  },
  methods: {
    getlist: function() {
      let params = {
        Keyword: this.filters.keyword.trim(),
        CreateOnFrom: moment(this.filters.fromTime)
          .utcOffset(480)
          .format('YYYY-MM-DD HH:mm:ss'),
        CreateOnTo: moment(this.filters.toTime)
          .utcOffset(480)
          .format('YYYY-MM-DD HH:mm:ss')
      }
      if (this.filters.status) {
        params.Status = this.filters.status
      }
      if (this.filters.repairshop) {
        params.RepairShop = this.filters.repairshop
      }
      this.$api
        .adminGetRepair(params)
        .then(res => {
          if (res.Status === 1) {
            this.datas = res.Entity
          } else {
            this.$alert(res.Message, '错误', {
              confirmButtonText: '确定'
            })
          }
        })
        .catch(function(res) {
          this.$alert('获取保修信息错误！', '错误', {
            confirmButtonText: '确定'
          })
        })
    },
    exportExcel() {
      /* generate workbook object from table */
      var wb = XLSX.utils.table_to_book(document.querySelector('#table-data'))
      /* get binary string as output */
      var wbout = XLSX.write(wb, {
        bookType: 'xlsx',
        bookSST: true,
        type: 'array'
      })

      try {
        FileSaver.saveAs(
          new Blob([wbout], { type: 'application/octet-stream' }),
          '设备报修信息' + new Date().getMilliseconds() + '.xlsx'
        )
      } catch (e) {
        if (typeof console !== 'undefined') console.log(e, wbout)
      }
      return wbout
    },
    dateFormat: function(row, column) {
      let time = dateFormat(row, column)
      return time
    },
    datetimeFormat: function(row, column) {
      let time = datetimeFormat(row, column)
      return time
    },

    visibleChange(isVisible) {
      const isEdge = window.navigator.userAgent.includes('Edge')
      if (isEdge && !isVisible) {
        document
          .querySelectorAll('body > .el-select-dropdown.el-popper')
          .forEach(it => it.remove())
      }
    }
  },
  created() {}
}



// WEBPACK FOOTER //
// ./src/admin/Repair/ExportRepair.vue